export const ConfigSettings = {
    GeneralSettings: {
        MapToolTip: "Map displays possible routes based on your search. Click on the route to view the detils"
    },
    MapSettings: {
        URL_TEMPLATE_TITLE: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        PathSettings: {
            Colors: ['blue', 'gray', 'green', 'orange', 'black'],
            Weight: 5,
            Opacity: 0.7
        },
    }
}